import React, { FunctionComponent } from "react";

//MUI
import Stack from "@mui/material/Stack";

type InfoPaneActionButtonsProps = {}

const InfoPaneActionButtons: FunctionComponent<React.PropsWithChildren<InfoPaneActionButtonsProps>> = (props) => {

  const numOfElements = React.Children.toArray(props.children).filter(x => x!== null).length;

  return (
    <Stack sx={{my: 2}} spacing={4} direction="row" alignItems="flex-start" justifyContent={numOfElements === 5 ? "space-between" : "flex-start"}>
      {props.children}
    </Stack>
  )
}

export default InfoPaneActionButtons;
